var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39,19.5A19.5,19.5,0,1,1,19.5,0,19.5,19.5,0,0,1,39,19.5Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,9.09A10.41,10.41,0,1,1,9.09,19.5,10.41,10.41,0,0,1,19.5,9.09ZM16.38,12.2A22.7,22.7,0,0,1,26.8,22.61c1.72,4-.15,5.91-4.18,4.19A22.72,22.72,0,0,1,12.2,16.38c-1.72-4,.15-5.9,4.18-4.18Zm10-.49A9.93,9.93,0,0,1,26,13.43c-1.63,5.33-7.27,11-12.6,12.6a9.93,9.93,0,0,1-1.72.38",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.5f8d33ee7e473e4a206b897f8c8bcb98.svg";
export { ForwardRef as ReactComponent };